// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/auth/v1/auth.proto" (package "c1.api.auth.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message c1.api.auth.v1.IntrospectRequest
 */
export interface IntrospectRequest {
}
/**
 * IntrospectResponse contains information about the current user who is authenticated.
 *
 * @generated from protobuf message c1.api.auth.v1.IntrospectResponse
 */
export interface IntrospectResponse {
    /**
     * The principleID of the current logged in user.
     *
     * @generated from protobuf field: string principle_id = 3;
     */
    principleId: string;
    /**
     * The list of roles that the current logged in user has.
     *
     * @generated from protobuf field: repeated string roles = 4;
     */
    roles: string[];
    /**
     * The list of permissions that the current logged in user has.
     *
     * @generated from protobuf field: repeated string permissions = 5;
     */
    permissions: string[];
    /**
     * The userID of the current logged in user.
     *
     * @generated from protobuf field: string user_id = 6;
     */
    userId: string;
    /**
     * The list of feature flags enabled for the tenant the logged in user belongs to.
     *
     * @generated from protobuf field: repeated string features = 11;
     */
    features: string[];
}
/**
 * @generated from protobuf message c1.api.auth.v1.GetRUMRequest
 */
export interface GetRUMRequest {
}
/**
 * @generated from protobuf message c1.api.auth.v1.GetRUMResponse
 */
export interface GetRUMResponse {
    /**
     * @generated from protobuf field: string datadog_rum_app_id = 1;
     */
    datadogRumAppId: string;
    /**
     * @generated from protobuf field: string datadog_rum_client_token = 2;
     */
    datadogRumClientToken: string;
    /**
     * @generated from protobuf field: string datadog_site = 3;
     */
    datadogSite: string;
    /**
     * @generated from protobuf field: string datadog_rum_env = 4;
     */
    datadogRumEnv: string;
    /**
     * @generated from protobuf field: string datadog_rum_version = 5;
     */
    datadogRumVersion: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class IntrospectRequest$Type extends MessageType<IntrospectRequest> {
    constructor() {
        super("c1.api.auth.v1.IntrospectRequest", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.auth.v1.IntrospectRequest
 */
export const IntrospectRequest = new IntrospectRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IntrospectResponse$Type extends MessageType<IntrospectResponse> {
    constructor() {
        super("c1.api.auth.v1.IntrospectResponse", [
            { no: 3, name: "principle_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "roles", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "permissions", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "features", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.auth.v1.IntrospectResponse
 */
export const IntrospectResponse = new IntrospectResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRUMRequest$Type extends MessageType<GetRUMRequest> {
    constructor() {
        super("c1.api.auth.v1.GetRUMRequest", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.auth.v1.GetRUMRequest
 */
export const GetRUMRequest = new GetRUMRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRUMResponse$Type extends MessageType<GetRUMResponse> {
    constructor() {
        super("c1.api.auth.v1.GetRUMResponse", [
            { no: 1, name: "datadog_rum_app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "datadog_rum_client_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "datadog_site", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "datadog_rum_env", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "datadog_rum_version", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.auth.v1.GetRUMResponse
 */
export const GetRUMResponse = new GetRUMResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.auth.v1.Auth
 */
export const Auth = new ServiceType("c1.api.auth.v1.Auth", [
    { name: "Introspect", options: { "authz.method": { role: "REFLECTION" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/auth/introspect", group: "Auth" }] } }, I: IntrospectRequest, O: IntrospectResponse },
    { name: "GetRUM", options: { "authz.method": { role: "REFLECTION" } }, I: GetRUMRequest, O: GetRUMResponse }
]);
